import Vue from 'vue'
import VueGtag from 'vue-gtag'

import router from './router'

const isEnabled = process.env.NODE_ENV === 'production'
// const isEnabled = true

Vue.use(VueGtag, {
  config: {
    id: CONFIG.analytics,
    params: {
      send_page_view: isEnabled,
    },
  },
  pageTrackerEnabled: isEnabled,
  appName: 'bandit.camp',
}, router)
